
import fetch ,{postFrom, getBlob} from "../utils/fetch";


export function findStoreFrontGradeList(params) {
  return fetch({
    method:'POST',
    url:'/storeFrontGrade/findStoreFrontGradeList',
    data:params
  })
}

export function deleteStoreFrontGrade(params) {
  return fetch({
    method:'GET',
    url:'/storeFrontGrade/deleteStoreFrontGrade',
    params
  })
}

export function addStoreFrontGrade(params) {
  return fetch({
    method:'POST',
    url:'/storeFrontGrade/addStoreFrontGrade',
    data:params
  })
}

export function findWorkOrderTypeList(params) {
  return fetch({
    method:'POST',
    url:'/workOrder/findWorkOrderTypeList',
    data:params
  })
}
